import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith, take } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

import { UnitPaymentService } from '../unit-payment.service';
import { TerraUtils } from '../../../../TerraUtils';
import { UnitPaymentStatus } from '../models/unit-payment-status.enum';
import { RoutingService } from '../../../../../services/routing.service';
import { Router } from '@angular/router';
import HoldingDiscriminator from '../../../../enums/HoldingDiscriminator.enum';

@Component({
  selector: 'terra-unit-payment-confirmation',
  templateUrl: './unit-payment-confirmation.component.html',
  styleUrls: ['./unit-payment-confirmation.component.scss', '../../unit-shared.scss'],
  providers: [UnitPaymentService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitPaymentConfirmationComponent implements OnInit {
  payment$ = this.paymentService.payment$;
  sourceBankAccount$ = this.paymentService.sourceBankAccount$;
  isLoading$ = combineLatest([this.payment$.pipe(startWith(null)), this.sourceBankAccount$.pipe(startWith(null))]).pipe(
    map(([payment, sourceBankAccount]) => !payment || !sourceBankAccount)
  );

  isGp:boolean;

  constructor(private paymentService: UnitPaymentService,
    private titleService: Title,
    private routingService: RoutingService,
    private router: Router) { 
      this.isGp = paymentService.isGp;
    }

  ngOnInit(): void {
    this.titleService.setTitle('Payment Confirmation' + TerraUtils.consts.GpPageTitleSuffix);
    this.payment$.pipe(
      take(1),
      filter(payment => !!payment)
    ).subscribe(payment => {
      if (payment.status !== UnitPaymentStatus.Sent &&
        payment.status !== UnitPaymentStatus.None) {
        if (this.paymentService.isGp) {
          this.router.navigateByUrl(this.routingService.paymentReviewPage(payment.id));
        }
        else {
          this.router.navigateByUrl(this.routingService.lpUnitPaymentReviewPage(payment.id));
        }
      }
    });
  }

  get bankAccountPage(): Observable<string> {
    return this.sourceBankAccount$.pipe(
      take(1),
      map(bankAccount => {
        if (this.paymentService.isGp) {
          return this.routingService.creBankAccountPage(bankAccount.id);
        }
        else {
          return this.routingService.lpUnitBankAccount(bankAccount.id);
        }
      })
    );
  }

  public navigateToHoldingPage(): void {
    this.sourceBankAccount$.pipe(
      take(1)
    ).subscribe(bankAccount => {
      const holding = bankAccount.unitApplication.holding;
      let url = '';
      if (holding.discriminator === HoldingDiscriminator.Asset) {
        url = this.routingService.gpAssetPage(holding.id);
      } else {
        url = this.routingService.gpFundPage(holding.id);
      }

      this.router.navigateByUrl(url);
    });
  }
}
